import type { JourneyStageKey, JourneyStateKey, OperationsJourneyCarrierKey } from "@/api/endpoints";

/** The six segments of the lifecycle bar, in order; Pre-release and Total are table-only rows. */
export const BAR_STAGES: readonly JourneyStageKey[] = ["intake", "preOnboarding", "awaitingRequest", "requestProcessing", "woSubmit", "woApproval"];

export const STAGE_LABEL: Record<JourneyStageKey, string> = {
  intake: "Intake",
  preOnboarding: "Pre-Verification",
  awaitingRequest: "Awaiting request",
  preRelease: "Pre-release",
  requestProcessing: "Request processing",
  woSubmit: "WO submit",
  woApproval: "WO approval",
  total: "Total (journey start → WO approval)",
};

export const STAGE_TIP: Record<JourneyStageKey, string> = {
  intake: "From the intake request's start (ATS placement, Client, Manual or VMS request) to its first record in FBO: the pre-verification's creation, else the work order's creation.",
  preOnboarding: "From the pre-verification request's creation to the work order's creation.",
  awaitingRequest: "From the work order's creation to the onboarding request's creation: the wait for someone to raise the request.",
  preRelease: "From the request's creation to its release. Folded into Request processing on the bar; its own row here.",
  requestProcessing: "From the request's creation to its last task done (FBO 'completed').",
  woSubmit: "From the request's last task done to the work order's submission.",
  woApproval: "From the work order's submission to its approval. Hatched when the work order was sent back; the counts come from the work-order sproc, FBO keeps no decline reasons we can read.",
  total: "From the journey's earliest record to the work order's approval (or the end without one). The peer median is the whole-request median the Requests screen uses.",
};

export const CARRIED_BY_LABEL: Record<OperationsJourneyCarrierKey, string> = {
  intake: "the intake (nothing in FBO yet)",
  preOnboarding: "the pre-verification request (no work order yet)",
  awaitingRequest: "the intake (work order created, awaiting its request)",
  request: "the request (work order not approved)",
  workOrder: "the work order (termination accepted, offboarding in progress)",
  none: "nobody",
};

export const JOURNEY_STATE_LABEL: Record<JourneyStateKey, string> = {
  notInFbo: "In progress",
  inPreOnboarding: "In progress",
  awaitingRequest: "In progress",
  inRequest: "In progress",
  offboarding: "In progress",
  complete: "Completed",
  canceled: "Canceled",
};

export const PEER_GROUP_TIP =
  "Completed requests with the same client, line of business and engagement type; falls back to client + line of business, then client, with at least 5 peers. " +
  "Per-stage medians count the peers on which that stage ran to its end. Business days on the Ontario calendar, Mon–Fri. The Intake stage has no peer median yet.";
